/**
  * This handles any special form element handling. 
  * Date Pickers, 
  */
  

P3Portal.Nav = {
  'scroll': function(){
    $(window).scroll(function(){
      P3Portal.Events.trigger('window.scroll', $(this).scrollTop());
    });
  },
  'Mobile': function(){
    $('.mobile-menu').click(function(e){
      $('.site-nav').slideToggle();
    });
  },
  'DoPrint': function(){
    $('#print-action').click(function(e){
      e.preventDefault();
      window.print();
      return false;
    });
  },
  
  'ShowNext': function(){
    $('.shownext').click(function(e){
      e.preventDefault();
      $(this).next().toggle();
      return false;
    });
  },
  'StageHelp': function(){
    if($('#workflow').length > 0){
      $('.stagetitle .fa').click(function(e){
        var parent = $(this).parent().parent();
        e.preventDefault();
        $('.stage-help', parent).toggle();
        return false;
      });
    }
  },
  'ShowHelp': function(){
    $('#help-action').click(function(e){
      e.preventDefault();
      $('.page-help').toggleClass('show');
      return false;
    });
  },
  'TableSort': function(){
    var sortable = $('table.sort');
    if(sortable.length > 0){
      var i = 0, len = sortable.length;
      for( i; i < len; i++){
        new Tablesort(sortable[i])
      }
    }
  },
  'AttachBarOnScroll': function(){
    var $attach = $('.onscroll-fix-top');
    if($attach.length > 0){
      var offset = $attach.offset();
      P3Portal.Events.on('window.scroll', function(position){
        if(position > offset.top){
          $attach.addClass('scrollfixed');
        }else{
          $attach.removeClass('scrollfixed');
        }
      });
    }
  },
  'Colorbox': function(){
    $('.colorbox').colorbox();
  },
  'ConfigButton': function(){
    var open = false;
    $('.row-config .config-btn').click(function(e){
      
      e.preventDefault();
      e.stopPropagation();
      var $this = $(this);
      var ul = $('ul', $this.parent());
      if(open){
        ul.hide();
        open = false;
      }else{
        $('.row-config ul').hide();
        ul.show();
        open = true;
      }
      $('body').one('click', function(){
        ul.hide();
        open = false;
      });
    });
  }
  
}
P3Portal.boot.push(P3Portal.Nav.scroll);
P3Portal.boot.push(P3Portal.Nav.DoPrint);
P3Portal.boot.push(P3Portal.Nav.StageHelp);
P3Portal.boot.push(P3Portal.Nav.AttachBarOnScroll);
P3Portal.boot.push(P3Portal.Nav.Mobile);
P3Portal.boot.push(P3Portal.Nav.ShowNext);
P3Portal.boot.push(P3Portal.Nav.ShowHelp);
P3Portal.boot.push(P3Portal.Nav.Colorbox);
P3Portal.boot.push(P3Portal.Nav.TableSort);
P3Portal.boot.push(P3Portal.Nav.ConfigButton);